@if (showSplash) {
  <div class="app-splash-screen d-flex flex-column justify-content-center align-items-center">
    <div class="app-logo"></div>
    <div class="w-50 splash-indicator-container">
      <cx-heart-beat class="w-25" [loading]="true"></cx-heart-beat>
    </div>
  </div>
}